import { render, staticRenderFns } from "./AskEmptyState.vue?vue&type=template&id=058e66fc&scoped=true&"
import script from "./AskEmptyState.vue?vue&type=script&lang=js&"
export * from "./AskEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./AskEmptyState.vue?vue&type=style&index=0&id=058e66fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e66fc",
  null
  
)

export default component.exports